var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-menu"
  }, [_c('div', {
    staticClass: "w1200 bc clearfix",
    staticStyle: {
      "min-height": "100px"
    }
  }, [_c('ul', {
    staticClass: "cols-1"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "font-weight": "900",
      "color": "#666"
    },
    attrs: {
      "href": "javasctipt:;"
    }
  }, [_vm._v(_vm._s(_vm.frendlinkList.name))])]), _vm._v(" "), _vm._l((_vm.frendlinkList.list), function(frendlink) {
    return _c('li', [_c('a', {
      attrs: {
        "href": frendlink.url
      }
    }, [_vm._v(_vm._s(frendlink.title))])])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "cols-2"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "font-weight": "900",
      "color": "#666"
    },
    attrs: {
      "href": "javasctipt:;"
    }
  }, [_vm._v(_vm._s(_vm.paymentList.name))])]), _vm._v(" "), _vm._l((_vm.paymentList.list), function(payment) {
    return _c('li', [_c('a', {
      attrs: {
        "href": payment.url
      }
    }, [_vm._v(_vm._s(payment.title))])])
  })], 2), _vm._v(" "), _c('ul', {
    staticClass: "cols-3"
  }, [_c('li', [_c('a', {
    staticStyle: {
      "font-weight": "900",
      "color": "#666"
    },
    attrs: {
      "href": "javasctipt:;"
    }
  }, [_vm._v(_vm._s(_vm.serviceList.name))])]), _vm._v(" "), _vm._l((_vm.serviceList.list), function(service) {
    return _c('li', [_c('a', {
      attrs: {
        "href": service.url
      }
    }, [_vm._v(_vm._s(service.title))])])
  })], 2)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ea9f91a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterMenu.vue
// module id = JXyc
// module chunks = 1